import { render, staticRenderFns } from "./StudentSheet.vue?vue&type=template&id=55b09ee4&scoped=true"
import script from "./StudentSheet.vue?vue&type=script&lang=js"
export * from "./StudentSheet.vue?vue&type=script&lang=js"
import style0 from "./StudentSheet.vue?vue&type=style&index=0&id=55b09ee4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b09ee4",
  null
  
)

export default component.exports